/**
 * @file date-picker.input.tsx
 * @description Компонент работы со временем и календарями. Отображение календаря зависит от переданного свойства type.
 * @author Genotroid
 * @created 2025-09-03
 * @updated 2025-09-09
 * @dependencies ['react', 'react-redux', '@store/slices/modals-queue-slice']
 * @related-files ['./components/date-picker.component.tsx', './components/date-time.component.tsx', './components/date-range.component.tsx']
 */

//TODO: реализовать закрытие всех открытых календарей при нажатии ESC
import { useId } from 'react';
// import { useDispatch, useSelector } from 'react-redux';
// import { addItem, removeItem, getItems } from '@store/slices/modals-queue-slice';
import { useSelector } from 'react-redux';
import { getItems } from '@store/slices/modals-queue-slice';
import { DatePicker as DateComponent, DateTimePicker, DateRangePicker } from './components/';

/**
 * Props для компонента выбора даты с различными типами отображения
 */
interface IDatePickerProps {
    /** Тип отображения календаря */
    type?: 'date-time' | 'date-range' | 'date';
    /** Значение даты или диапазона дат */
    value?: number | number[];
    /** Обработчик изменения значения */
    onChange?: (value: number | number[] | null) => void;
    /** Текст метки */
    label?: string;
    /** Режим только для чтения */
    readOnly?: boolean;
    /** CSS класс */
    className?: string;
    /** Обработчик потери фокуса */
    onBlur?: () => void;
    /** Функция для установки значения даты */
    setValue?: (value: number | number[] | null) => void;
}

export const DatePicker = ({ type = 'date', value, ...props }: IDatePickerProps) => {
    // const dispatch = useDispatch();
    const id = useId();
    const items = useSelector(getItems);

    const RemoveModalFromQueueById = () => {
        // setTimeout(() => dispatch(removeItem(id)), 50);
    };

    const AddModal = () => {
        // setTimeout(() => dispatch(addItem(id)), 50);
    };

    switch (type) {
        case 'date-time':
            return (
                <DateTimePicker
                    {...props}
                    value={(value as number) || 0}
                    removeModalFromQueueById={RemoveModalFromQueueById}
                    addModal={AddModal}
                    modalId={id}
                    currentModalsQueue={items}
                />
            );
        case 'date-range':
            return (
                <DateRangePicker
                    {...props}
                    value={value as [number | null, number | null]}
                    onChange={props.onChange as ((value: [number | null, number | null]) => void) | undefined}
                    removeModalFromQueueById={RemoveModalFromQueueById}
                    addModal={AddModal}
                    modalId={id}
                    currentModalsQueue={items}
                />
            );
        default:
            return (
                <DateComponent
                    {...props}
                    value={value as number}
                    removeModalFromQueueById={RemoveModalFromQueueById}
                    addModal={AddModal}
                    modalId={id}
                    currentModalsQueue={items}
                />
            );
    }
};
